<template>
  <div class="fan fan-component f-plugin-list">
    <f-layout ref="flayout"
              :superPage="page"
              :superApi="syncedApi"
              @reloadData="loadData">
      <!-- 面包屑 -->
      <!-- <template #breadcrumb></template> -->
      <!-- 头部 -->
      <template #head v-if="superTitle || $slots.subHead">
        <div class="head" style="padding:20px;font-size: 1.1em; font-weight: bold;display:flex;align-items:center;gap:8px;"
             v-if="superTitle">
          <span>{{ superTitle }}</span>
          <a-tooltip v-if="superHelp" :content="superHelp" position="bottom">
            <icon-question-circle style="color:#86909c;cursor:help;font-size:16px;" />
          </a-tooltip>
        </div>
        <div class="subHead" v-if="$slots.subHead"><slot name="subHead"></slot></div>
      </template>
      <!-- 检索 -->
      <template #subHeadLeft v-if="$slots.subHeadLeft">
        <slot name="subHeadLeft"></slot>
      </template>
      <template #subHeadLeft v-else-if="superApi && superColumns">
        <f-search :superFilter="page.filter"
                  :superColumns="superColumns"
                  @change="bindSearchChange"
                  @reloadData="reloadData()">
        </f-search>
      </template>
      <!-- 按钮组 -->
      <template #subHeadRight v-if="$slots.subHeadRight">
        <slot name="subHeadRight"></slot>
      </template>
      <!-- 子菜单 -->
      <template #menus v-if="menus">
        <div class="menu-backdrop">
          <a-menu
              mode="vertical"
              :open-keys="openNames"
              :selected-keys="[activeMenu]"
              @menu-item-click="handleMenuSelect"
              @sub-menu-popup-visible-change="handleOpenChange"
            >
          <!-- 递归渲染菜单 -->
          <template v-for="item in menuList">
            <a-sub-menu v-if="item.info.show && item.info.hasChild"
                    :key="'submenu-' + item.info.url" :key-path="[item.info.url]">
              <template #title><component :is="'icon-' + (item.info.icon || 'appstore') || ''" /><span>{{item.info.name}}</span></template>
              <!-- 递归渲染子菜单 -->
              <template v-for="child in item.children">
                <a-sub-menu v-if="child.info.show && child.info.hasChild"
                        :key="'submenu-' + child.info.url" :key-path="[child.info.url]">
                  <template #title><component :is="'icon-' + (child.info.icon || 'appstore') || ''" /><span>{{child.info.name}}</span></template>
                  <!-- 递归渲染更深层级的子菜单 -->
                  <template v-for="grandchild in child.children">
                    <a-sub-menu v-if="grandchild.info.show && grandchild.info.hasChild"
                            :key="'submenu-' + grandchild.info.url" :key-path="[grandchild.info.url]">
                      <template #title><component :is="'icon-' + (grandchild.info.icon || 'appstore') || ''" /><span>{{grandchild.info.name}}</span></template>
                      <template v-for="greatgrandchild in grandchild.children">
                        <a-menu-item :key="'menu-' + greatgrandchild.info.url"
                                  v-if="greatgrandchild.info.show"
                                  @click="$fan.page.open(greatgrandchild.info.url)">
                          <component :is="'icon-' + (greatgrandchild.info.icon || 'appstore') || ''" />
                          <span>{{greatgrandchild.info.name}}</span>
                        </a-menu-item>
                      </template>
                    </a-sub-menu>
                    <a-menu-item v-else-if="grandchild.info.show"
                              :key="'menu-' + grandchild.info.url"
                              @click="$fan.page.open(grandchild.info.url)">
                      <component :is="'icon-' + (grandchild.info.icon || 'appstore') || ''" />
                      <span>{{grandchild.info.name}}</span>
                    </a-menu-item>
                  </template>
                </a-sub-menu>
                <a-menu-item v-else-if="child.info.show"
                          :key="'menu-' + child.info.url"
                          @click="$fan.page.open(child.info.url)">
                  <component :is="'icon-' + (child.info.icon || 'appstore') || ''" />
                  <span>{{child.info.name}}</span>
                </a-menu-item>
              </template>
            </a-sub-menu>
            <a-menu-item v-else-if="item.info.show"
                      :key="'menu-' + item.info.url"
                      @click="$fan.page.open(item.info.url)">
              <component :is="'icon-' + (item.info.icon || 'appstore') || ''" />
              <span>{{item.info.name}}</span>
            </a-menu-item>
          </template>
        </a-menu>
        </div>

      </template>
      <!-- 列表 -->
      <template #body v-if="$slots.body">
        <slot name="body"></slot>
      </template>
      <template #body v-else-if="superApi && superColumns">
        <f-table 
                 ref="ftable"
                 :superData="data"
                 :superColumns="(superColumns && superColumns.length) ? superColumns : $store.state.page.tableColumns"
                 :superFilter="page.filter"
                 :superLoading="page.loading || page.initing || !localKeyinfo"
                 :superKeyinfo="localKeyinfo"
                 @change="bindTableChange"
                 @reloadData="reloadData()"
                 @view="(record) => $refs.flayout.bindOpenCurd('详情', { record })"
                 @edit="(record) => $refs.flayout.bindOpenCurd('编辑', { record })"
                 @delete="bindDeleteRecord">
          <!-- 表格工具栏左侧 -->
          <template #toolbarLeft>
            <slot name="toolbarLeft">
              <a-button type="primary" status="success" @click="$refs.flayout.bindOpenCurd('新增')"><icon-plus />新增</a-button>
              <!-- <a-upload :auto-upload="false" :show-file-list="false" accept=".xlsx,.xls,.csv" @change="bindImportExcel">
                <a-button><icon-upload />导入</a-button>
              </a-upload> -->
            </slot>
          </template>
          <!-- 传递自定义操作列模板 -->
          <template #action="{ record }" v-if="$slots.action">
            <slot name="action" :record="record"></slot>
          </template>
        </f-table>
      </template>
    </f-layout>
  </div>
</template>

<script>
  import moment from 'moment'
  import 'moment/locale/zh-cn'
  moment.locale('zh-cn')
  import * as XLSX from 'xlsx'

  export default {
    name: 'FPluginList',
    // components: { IconLeft, IconRefresh, IconPlus, IconEye, IconEdit, IconDelete, IconUpload },
    props: {
      superTitle: String,
      superApi: String,
      superColumns: Array,
      superHelp: String,
    },

    created() {
      this.page = this.$fan.utils.parse(this.def.page)
      this.data = this.$fan.utils.parse(this.def.data)
    },

    async mounted() {
      if (this.superApi && this.superColumns) {
        await this.reloadData()
      }
    },
    async activated() {
      // keepAlive 缓存激活时重新加载数据（每次切回自动刷新，带正常 loading）
      if (this.superApi && this.superColumns) {
        await this.reloadData()
      }
    },
    computed: {
      routers() {
        return this.$store.state.routers || {}
      },
      router() {
        const pathWithoutQuery = this.$route.path.split('?')[0]
        const allRoutes = Object.values(this.routers)
        
        let route = allRoutes.find(item => item.info && item.info.url === pathWithoutQuery)
        if (route) return route
        
        const sortedRoutes = [...allRoutes].sort((a, b) => {
          const lenA = a.info && a.info.url ? a.info.url.length : 0
          const lenB = b.info && b.info.url ? b.info.url.length : 0
          return lenB - lenA
        })
        
        route = sortedRoutes.find(item => item.info && item.info.url && pathWithoutQuery.startsWith(item.info.url))
        if (route) return route
        
        route = allRoutes.find(item => item.info && item.info.url === this.$route.path)
        if (route) return route
        
        return {}
      },
      query() {
        const query = this.$route.query
        if (this.$fan.utils.notEmpty(query)) {
          return query
        } else {
          return false
        }
      },
      // 供列表请求与增改表单（FLayout→FForm）共用的 API 地址：
      // 父页面（如 dictlist）把 api 写死在 data() 里，keep-alive 复用实例时不再重算，
      // 这里用当前路由参数覆盖同名参数、清理 undefined/null 残留、追加新参数，
      // 保证 GET 列表与新增提交（FForm 会把 URL 参数作为隐藏归属字段提交）都归属当前分类
      syncedApi() {
        let api = this.superApi
        const rq = this.$route.query || {}
        const queryKeys = Object.keys(rq).filter(k => rq[k] !== undefined && rq[k] !== null && rq[k] !== '')
        if (api) {
          const qIndex = api.indexOf('?')
          const base = qIndex === -1 ? api : api.slice(0, qIndex)
          const params = new URLSearchParams(qIndex === -1 ? '' : api.slice(qIndex + 1))
          // 清理写死/残留的无意义参数（undefined、null、空串），避免带着“历史参数”
          const removeKeys = []
          params.forEach((v, k) => {
            if (v === 'undefined' || v === 'null' || v === '') removeKeys.push(k)
          })
          removeKeys.forEach(k => params.delete(k))
          // 用当前路由参数覆盖同名参数、追加新参数，保证请求与地址栏一致
          queryKeys.forEach(k => params.set(k, String(rq[k])))
          api = base + (params.toString() ? '?' + params.toString() : '')
        }
        return api
      },
      menus() {
        if (!this.router || !this.router.info || !this.router.info.path) return false
        
        const path = this.router.info.path
        return (path.length === 5 || path.length === 6) && this.menuList.length > 0
      },
      menuReady() {
        return this.menuList.length > 0 && this.openNames.length >= 0
      },
      menuList() {
        const currentPath = this.$route.path.split('?')[0]
        const all = Object.values(this.$store.state.routers)
        
        let currentRouter = all.find(item => item.info && item.info.url === currentPath)
        
        if (!currentRouter) {
          const sortedRoutes = [...all].sort((a, b) => {
            const lenA = a.info && a.info.url ? a.info.url.length : 0
            const lenB = b.info && b.info.url ? b.info.url.length : 0
            return lenB - lenA
          })
          
          currentRouter = sortedRoutes.find(item => item.info && item.info.url && currentPath.startsWith(item.info.url))
        }
        
        if (!currentRouter || !currentRouter.info || !currentRouter.info.path) return []

        const path = currentRouter.info.path

        const parentPath = path.slice(0, -1)
        const parentUrl = '/' + parentPath.join('/')

        const siblings = all.filter(item => {
          if (!item.info || !item.info.path || !item.info.show) return false
          if (item.info.path.length !== path.length) return false

          const itemParent = item.info.path.slice(0, -1)
          return '/' + itemParent.join('/') === parentUrl
        })

        return this.buildMenuTree(siblings, all)
      },

      openNames() {
        const storageKey = `fan-menu-open-names-${this.$route.path}`
        const savedOpenNames = localStorage.getItem(storageKey)
        if (savedOpenNames) {
          try {
            return JSON.parse(savedOpenNames)
          } catch (e) {}
        }

        // 默认收起，用户手动点击才展开
        return []
      },
      activeMenu() {
        const storageKey = `fan-menu-active-${this.$route.path}`
        const savedActive = localStorage.getItem(storageKey)
        if (savedActive) {
          return savedActive
        }
        const active = this.$route.path.split('?')[0]
        return active
      }, 
      menuStyle() {
          return {
            height: '100%',
            borderRight: 0,
            backgroundColor: 'var(--menu-bg, #fff)',
            color: 'var(--menu-text, #000)'
          }
      },
    },
    data() {
      return {
        data: { data: [], count: 0 }, page: {},
        menuVisible: false,
        localKeyinfo: null, // 页面级缓存keyinfo，防止被其他页面覆盖全局store
        def: {
          data: {},
          page: {
            initing: false,
            loading: false,
            filter: {
              page: 1,
              limit: 10
            }
          }
        }
      }
    },
    watch: {
      '$route': {
        handler(to, from) {
          this.$nextTick(() => {
            // 同一路径仅 URL 参数变化（父页面带新参数跳入同一条路由、keep-alive 未走激活流程）：
            // 必须用新参数重新加载，否则仍展示上一次的参数/数据
            if (to && from && to.path === from.path
                && JSON.stringify(to.query || {}) !== JSON.stringify(from.query || {})) {
              this.reloadData()
              return
            }
            this.$forceUpdate()
          })
        },
        deep: true
      }
    },
    methods: {
      buildMenuTree(menuItems, allRouters) {
        return menuItems.map(item => {
          const children = allRouters.filter(child => {
            if (!child.info || !child.info.path || !child.info.show) return false
            if (child.info.path.length !== item.info.path.length + 1) return false
            
            const childParent = child.info.path.slice(0, -1)
            const childParentUrl = '/' + childParent.join('/')
            const itemUrlWithoutQuery = item.info.url.split('?')[0]
            return childParentUrl === itemUrlWithoutQuery
          })

          if (children.length > 0) {
            item.children = this.buildMenuTree(children, allRouters)
            item.info.hasChild = true
          } else {
            item.info.hasChild = false
          }

          return item
        })
      },
      async loadData() {
        this.page.loading = true
        this.localKeyinfo = null  // 重置，等keyinfo就绪后一起显示
        // 过滤掉不在 columns 中的多余查询字段（避免报错如 istrusted does not exist）
        const validKeys = new Set(this.superColumns.map(c => c.dataIndex))
        const cleanFilter = { ...this.page.filter, page: this.page.filter.page || 1, limit: this.page.filter.limit || 10 }
        for (const k in cleanFilter) {
          if (!['page', 'limit'].includes(k) && !validKeys.has(k)) {
            delete cleanFilter[k]
          }
        }
        // 用 syncedApi（superApi 基址 + 当前路由参数覆盖/追加）作为请求地址
        const api = this.syncedApi
        const res = await this.$fan.api.get(api, cleanFilter)
        /* 关键修复：先等 loadCallback 完成（异步加载 extendTable 的 options/keyinfo），再赋值 data */
        this.$store.state.page.data = res
        await this.$fan.page.loadCallback(this.superColumns, res)
        this.data = this.$fan.utils.parse(res)
        // 页面级缓存keyinfo
        if (this.$store.state.page?.keyinfo) {
          this.localKeyinfo = { ...this.$store.state.page.keyinfo }
        }
        this.page.loading = false
      },
      async reloadData() {
        this.page.initing = true
        this.localKeyinfo = null
        this.page.filter = this.$fan.utils.parse(this.def.page.filter)
        await this.loadData()
        if (this.$store.state.page?.keyinfo) {
          this.localKeyinfo = { ...this.$store.state.page.keyinfo }
        }
        this.page.initing = false
      },
      async bindSearchChange(filter={}) {
        this.page.loading = true
        this.page.filter = {...filter, ...this.def.page.filter}
        await this.loadData()
        await this.$fan.page.loadCallback(this.superColumns, this.data)
        this.page.loading = false
      },
      bindTableChange(pagination, filters, sorter) {
        this.page.filter.page = pagination.current
        this.page.filter.limit = pagination.pageSize
        this.loadData()
      },
      async bindDeleteRecord({record}) {
        const apis = this.superApi.split('?')[0]
        let api = ''
        if(this.superApi.indexOf('v_')>-1){
          api = apis.slice(2)
        } else if(this.superApi.indexOf('v2_')>-1){
          api = apis.slice(3)
        } else{
          api = apis
        }
        await this.$fan.api.delete(`${api}/${record.id}`)
        this.loadData()
      },
      handleOpenChange(keys) {
        const storageKey = `fan-menu-open-names-${this.$route.path}`
        localStorage.setItem(storageKey, JSON.stringify(keys))
      },
      handleMenuSelect(name) {
        const storageKey = `fan-menu-active-${this.$route.path}`
        localStorage.setItem(storageKey, name)
      },
      // 批量导入 Excel
      async bindImportExcel(fileList) {
        if (!fileList || !fileList.file) return
        const file = fileList.file
        const reader = new FileReader()
        reader.onload = async (e) => {
          try {
            const data = new Uint8Array(e.target.result)
            const workbook = XLSX.read(data, { type: 'array' })
            const sheetName = workbook.SheetNames[0]
            const worksheet = workbook.Sheets[sheetName]
            const jsonData = XLSX.utils.sheet_to_json(worksheet)
            if (jsonData.length === 0) { this.$message.warning('Excel 中没有数据'); return }
            this.$modal.confirm({
              title: '批量导入',
              content: `共 ${jsonData.length} 条数据，是否确认导入？`,
              onOk: async () => {
                let successCount = 0
                for (const row of jsonData) {
                  try { await this.$fan.api.post(this.superApi.split('?')[0].replace(/v_?2?_?/, ''), row); successCount++ }
                  catch {}
                }
                this.$message.success(`导入完成，成功 ${successCount} 条`)
                this.loadData()
              }
            })
          } catch (err) {
            this.$message.error('文件解析失败，请检查格式是否正确')
          }
        }
        reader.readAsArrayBuffer(file)
      },
    }
  }
</script>
